import { InfoIcon, styled } from 'sp-ui';

const BannerInfoIcon = styled(InfoIcon)`
    flex: 0 0 24px;
    height: 24px;
    margin-right: 16px;
`;

export default BannerInfoIcon;
